import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../modules/stores';
import routes from '../../../modules/routes/index.routes';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '../../../modules/hooks/tools/use-route';
import { useDestinationHeaders } from '../../../modules/hooks/theaders/destination.headers';
import styles from './destinations.module.scss';
import { useList } from '../../../modules/hooks/tools/use-list';
import { useStateBetweenPages } from '../../../modules/hooks/tools/use-state-between-pages';
import { DestinationModel } from '../../../modules/models/destination.model';

const pageBarDebugProps = { dataAttrs: [new DataAttribute('id', 'destinations_pagebar')] };

export const Destinations: FC = observer(() => {
	const { destinationStore } = useStores<IAdminxStore>();

	const { currentRouteWithoutSpecialChars } = useRoute();

	const { columns } = useDestinationHeaders();
	const stateBetweenPages = useStateBetweenPages(() => destinationStore.listStore.getList().length !== 0);

	useList<DestinationModel>(destinationStore.listStore, undefined, stateBetweenPages);

	return (
		<Page>
			<Pagebar debugProps={pageBarDebugProps}>
				<PagebarTitle>Destinations</PagebarTitle>
			</Pagebar>

			<div className={styles.tableWrapper}>
				<ControlledTable
					currentRoute={currentRouteWithoutSpecialChars}
					createRoute={routes.destinations.create()}
					columns={columns}
					data={destinationStore.listStore.getList()}
					isLoading={destinationStore.listStore.getIsLoading()}
				/>
			</div>
		</Page>
	);
});
